/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvoucherstate2Inputs */

const en_dropvoucherstate2 = /** @type {(inputs: Dropvoucherstate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher`)
};

const de_dropvoucherstate2 = /** @type {(inputs: Dropvoucherstate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gutschein`)
};

/**
* | output |
* | --- |
* | "Voucher" |
*
* @param {Dropvoucherstate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvoucherstate2 = /** @type {((inputs?: Dropvoucherstate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvoucherstate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvoucherstate2(inputs)
	return de_dropvoucherstate2(inputs)
});
export { dropvoucherstate2 as "dropVoucherState" }